"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidDate = exports.formatISODate = exports.formatRelativeDate = exports.formatDate = void 0;
const date_fns_1 = require("date-fns");
const formatDate = (date, formatStr = 'PPP') => {
    const dateObj = typeof date === 'string' ? (0, date_fns_1.parseISO)(date) : date;
    return (0, date_fns_1.format)(dateObj, formatStr);
};
exports.formatDate = formatDate;
const formatRelativeDate = (date) => {
    const dateObj = typeof date === 'string' ? (0, date_fns_1.parseISO)(date) : date;
    return (0, date_fns_1.formatDistanceToNow)(dateObj, { addSuffix: true });
};
exports.formatRelativeDate = formatRelativeDate;
const formatISODate = (date = new Date()) => {
    return date.toISOString();
};
exports.formatISODate = formatISODate;
const isValidDate = (date) => {
    try {
        const parsed = (0, date_fns_1.parseISO)(date);
        return !isNaN(parsed.getTime());
    }
    catch {
        return false;
    }
};
exports.isValidDate = isValidDate;
